import { render, staticRenderFns } from "./PLinkButton.vue?vue&type=template&id=43159075"
import script from "./PLinkButton.vue?vue&type=script&lang=js"
export * from "./PLinkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports